// src/components/Admin/ContentManager.jsx
import { useState } from 'react';
import {
    Box,
    Tabs,
    Tab,
    Typography,
    Paper,
} from '@mui/material';

import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';     // 🆕 그룹 탭
import ListAltIcon from '@mui/icons-material/ListAlt';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ReceiptLongSharpIcon from '@mui/icons-material/ReceiptLongSharp';  // 타이틀 아이콘

import BoardGroupManager from './BoardGroupManager';   // 🆕
import BoardCategories from './BoardCategoryManager';
import ChatManager from './ChatManager';

const ContentManager = ({ userInfo }) => {
    const [tab, setTab] = useState(0);   // 0: 그룹, 1: 게시판, 2: 채팅

    return (
        <Box
            sx={{
                p: 4,
                '@media (max-width:600px)': { p: 2 },
            }}
        >
            {/* ─── 타이틀 ─── */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                <ReceiptLongSharpIcon
                    sx={{
                        fontSize: '2rem',
                        '@media (max-width:600px)': { fontSize: '1.5rem' },
                    }}
                />
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 'bold',
                        '@media (max-width:600px)': { fontSize: '1.3rem' },
                    }}
                >
                    게시판 · 채팅방 관리
                </Typography>
            </Box>

            {/* ─── 1차 탭 선택 ─── */}
            <Paper
                elevation={2}
                sx={{
                    mb: 3,
                    borderRadius: 2,
                    backgroundColor: '#f5f5f5',
                    px: 2,
                    '@media (max-width:600px)': { px: 1 },
                }}
            >
                <Tabs
                    value={tab}
                    onChange={(_, v) => setTab(v)}
                    textColor="primary"
                    indicatorColor="primary"
                    variant="fullWidth"
                    sx={{
                        minHeight: 48,
                        '& .MuiTab-root': {
                            minHeight: 48,
                            '@media (max-width:600px)': {
                                fontSize: '0.85rem',
                                minHeight: 42,
                                px: 0.5,
                            },
                        },
                    }}
                >
                    <Tab
                        icon={<FolderSpecialIcon />}          // 📂 그룹
                        iconPosition="start"
                        label="그룹 관리"
                    />
                    <Tab
                        icon={<ListAltIcon />}                // 📋 카테고리
                        iconPosition="start"
                        label="게시판 관리"
                    />
                    <Tab
                        icon={<ChatBubbleOutlineIcon />}      // 🗣️ 채팅
                        iconPosition="start"
                        label="채팅방 관리"
                    />
                </Tabs>
            </Paper>

            {/* ─── 탭별 콘텐츠 ─── */}
            {tab === 0 && <BoardGroupManager />}              {/* 그룹 */}
            {tab === 1 && <BoardCategories userInfo={userInfo} />}  {/* 카테고리 */}
            {tab === 2 && <ChatManager />}                    {/* 채팅 */}
        </Box>
    );
};

export default ContentManager;
